import { SvgStar, Text } from '@loomhq/lens';
import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

import styles from './CollapsedChecklist.module.less';

const transitionClasses = {
  enter: styles.transitionEnter,
  enterActive: styles.transitionEnterActive,
  leave: styles.transitionLeave,
  leaveActive: styles.transitionLeaveActive,
};

export default function CollapsedChecklist({
  animatedTaskId,
  badgeNumber,
  onClick,
  tasks,
}) {
  const animatedTask = tasks.find(task => task.id === animatedTaskId);

  return (
    <button className={styles.collapsedButton} onClick={onClick}>
      <span className={styles.collapsedButtonStar}>
        <CSSTransitionGroup
          transitionName={transitionClasses}
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
          className="flex"
        >
          {!animatedTask && <SvgStar />}
          {animatedTask && (
            <i className={styles.emojiIcon}>{animatedTask.completionIcon}</i>
          )}
        </CSSTransitionGroup>
        {badgeNumber && badgeNumber > 0 && (
          <span className={styles.collapsedButtonBadge}>
            <Text size="small" fontWeight="bold" color="white">
              {badgeNumber}
            </Text>
          </span>
        )}
      </span>
    </button>
  );
}
